export default Object.freeze({
  AsistenteEnTerapiaFisica: 1,
  AsistenteEnTerapiaOcupacional: 2,
  Audiólogo: 3,
  CertificadoEnAsistenciaTecnológica: 4,
  Neurólogo: 5,
  Oftalmólogo: 6,
  Optómetra: 7,
  Otorrinolaringólogo: 8,
  PatólogoDelHabla: 9,
  Pediatra: 10,
  Psicólogo: 11,
  Psiquiatra: 12,
  TerapistaFisico: 13,
  TerapistaHablayLenguaje: 14,
  TerapistaOcupacional: 15,
  ServicioEducativo: 16,
  AsistenteDeServicio: 17,
});
